export default "__VITE_ASSET__DYG90wjm__"